<template>
  <div ref="wrapRef" class="user-select" :style="props.style">
    <a-select
      v-model:value="userId"
      style="width: 100%"
      :options="userOptions"
      :allow-clear="allowClear"
      :placeholder="placeholder"
      :show-search="true"
      :filter-option="filterOption"
      option-filter-prop="label"
      popup-class-name="user-select-dropdown"
      :dropdown-style="{ zIndex: 999 }"
      :get-popup-container="getPopupContainer"
      @select="handleSelect"
      @change="handleChange"
    ></a-select>
  </div>
</template>

<script setup lang="ts">
import { ref, type CSSProperties } from 'vue'
import * as adminAPI from '@/api/admin'

defineOptions({
  name: 'userSelect',
})

type Props = {
  style?: CSSProperties
  allowClear?: boolean
  placeholder?: string
  hasFull?: boolean
  userType?: string
}
const props = withDefaults(defineProps<Props>(), {
  style: () => ({ width: '100%' }),
  allowClear: false,
  placeholder: '请选择',
  hasFull: false,
  userType: 'manager',
})

type Option = {
  class: string
  disabled: boolean
  key: string
  title: string
  value: string | number | undefined
}

const emit = defineEmits<{
  (e: 'change', value: string | null, option: Option): void
  (e: 'select', value: string | null, option: Option): void
}>()

const userId = defineModel<string | null>('userId', {
  default: null,
})

const wrapRef = ref<HTMLElement | null>(null)

/** 挂到组件容器内，避免下拉层挂到 body 后盖住 sticky 顶栏 */
const getPopupContainer = () => wrapRef.value || document.body

const userOptions = ref<{ label: string; value: string | null }[]>([])

// 模糊搜索过滤函数
const filterOption = (input: string, option?: { label: string; value: string | null }) => {
  if (!input) return true
  const label = option?.label ?? ''
  return label.toLowerCase().includes(input.toLowerCase())
}

const fetchUserList = async () => {
  try {
    const res = await adminAPI.queryUserList({
      pageNo: 1,
      pageSize: 10000,
      account: '',
      userName: '',
      userType: props.userType,
      enableFlag: null,
      tenantId: null,
    })
    console.log('🔍 API 返回数据:', res.data)
    if (Array.isArray(res?.data?.rows)) {
      userOptions.value = res?.data?.rows.map((item) => ({
        label: item.userName || '',
        value: item.userId || null,
      }))
      console.log('✅ 转换后的用户列表:', userOptions.value)
    } else {
      userOptions.value = []
      console.warn('⚠️ 返回数据格式不正确，rows 不是数组')
    }
    if (props.hasFull) {
      userOptions.value.unshift({ label: '全部', value: null })
    }
  } catch (error) {
    console.error('❌ 获取用户列表失败', error)
    userOptions.value = []
  }
}

fetchUserList()

const handleSelect = (value: string | null, option: Option) => {
  emit('select', value, option)
}

const handleChange = (value: string | null, option: Option) => {
  emit('change', value, option)
}
</script>

<style lang="less">
.user-select {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  overflow: visible;
}

/* 顶栏 z-index 为 1100，下拉层不得高于顶栏 */
.ant-select-dropdown.user-select-dropdown {
  z-index: 999;
}
</style>
